import { FormattedMessage } from 'react-intl'
import { getRouteApi } from '@tanstack/react-router'

import { Alert } from '@gto/ui/alert'
import { Button } from '@gto/ui/button'
import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { EnvelopeOpenIcon } from '@gto/ui/icons/outline'
import { colors } from '@gto/ui/theme/design-tokens'
import { Typography } from '@gto/ui/typography'

import { FormContainer } from '@/components/form-container'
import { defaultAuthQuery } from '@/pages/auth/search-schema'

const routeApi = getRouteApi('/_auth/login/verify-email/')
export const RootRoute = () => {
  const navigate = routeApi.useNavigate()
  const { status } = routeApi.useLoaderData()
  const isSmAndLower = useMediaQuery('down', 'sm')

  const isError = status === 'error'

  return (
    <FormContainer>
      <Typography
        gutterBottom
        className="flex items-center gap-2"
        variant={isSmAndLower ? 'h5' : 'h4'}
      >
        <EnvelopeOpenIcon
          color={colors.primary.main}
          height={36}
        />{' '}
        <FormattedMessage id="auth.emailValidation.title" />
      </Typography>
      {isError ? (
        <>
          <Alert
            heading={<FormattedMessage id="auth.emailValidation.error" />}
            severity="warning"
          />
          <Button
            color="primary"
            size="large"
            variant="contained"
            onClick={() => {
              navigate({
                to: '/login',
                viewTransition: true,
                search: defaultAuthQuery,
                replace: true,
              }).catch(console.error)
            }}
          >
            <FormattedMessage id="common.controls.backToLogin" />
          </Button>
        </>
      ) : (
        <>
          <Typography
            className="whitespace-pre-line"
            color="text.secondary"
            variant="body1"
          >
            <FormattedMessage id="auth.emailValidation.description" />
          </Typography>
        </>
      )}
    </FormContainer>
  )
}
